import { render, staticRenderFns } from "./Video_Header.vue?vue&type=template&id=5359c418&"
import script from "./Video_Header.vue?vue&type=script&lang=js&"
export * from "./Video_Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports